
@if(isDataLoading){
        <div class="example-loading-shade">
            @if(isDataLoading){
            <mat-spinner></mat-spinner>}
        </div>}
        @if(showFilter){
        <div>
            <mat-accordion #accordion="matAccordion" [multi]="true">
                <!--Filter Code  -->
                <mat-expansion-panel [expanded]="true">
                    <mat-panel-description>
                        <div class="col-lg-12 nopadding">
                            <div class="panel-description">
                                <div class="col-lg-9 nopadding">
                                    <div class="panel-left-section">
                                        <mat-chip-listbox aria-label="filter">
                                            <span>
                                                <label for="parentChildEventTree">
                                                    <i class="fa fa-filter" id="parent-child-event-tree-filter"></i>
                                                </label>
                                                <mat-chip selected color="green" matTooltip="Date" [matTooltipShowDelay]="1000" matTooltipPosition="after"
                                                    id="parent-child-event-tree-date">
                                                    Report Date: {{reportDate}}
                                                </mat-chip>
                                                <mat-chip selected color="green" matTooltip="Symbol" [matTooltipShowDelay]="1000" matTooltipPosition="after"
                                                    id="parent-child-event-tree-symbol">
                                                    Symbol: {{symbol}}
                                                </mat-chip>
                                                <mat-chip selected color="green" matTooltip="Order ID" [matTooltipShowDelay]="1000" matTooltipPosition="after"
                                                    id="parent-child-event-tree-orderID">
                                                    Order ID: {{orderID}}
                                                </mat-chip>
                                                <mat-chip selected color="green" matTooltip="Order Date" [matTooltipShowDelay]="1000" matTooltipPosition="after"
                                                    id="parent-child-event-tree-orderDate">
                                                    Order Date: {{orderDate | date: 'yyyy-MM-dd' }}
                                                </mat-chip>
                                                <mat-chip selected color="green" matTooltip="Side" [matTooltipShowDelay]="1000" matTooltipPosition="after"
                                                    id="parent-child-event-tree-side">
                                                    Side: {{side}}
                                                </mat-chip>
                                                <mat-chip selected color="green" matTooltip="Event Type" [matTooltipShowDelay]="1000" matTooltipPosition="after"
                                                    id="parent-child-event-tree-eventType">
                                                    Event Type: {{type}}
                                                </mat-chip>
                                            </span>
                                        </mat-chip-listbox>
                                    </div>
                                </div>
                                <div class="col-lg-3 nopadding">
                                    <div class="panel-right-section">
                                        <section class="example-section">
                                            <div class="btnPanel">
                                                <!-- Show Parent and Use OrderKeyDate manually -->
                                                <label for="showParentBtn">
                                                    <p-button type="button" id="showParentBtn" label="Show Parent" (onClick)="showParent();" class="form-action-button"></p-button>
                                                </label>
                                                <mat-checkbox id="matchOrderKeyDate" class="matchOrderKeyDateChkBox" [(ngModel)]="checkedUseOrderKeyDate" (change)="toggleUseOrderKeyDate($event)">Match Using OrderDate </mat-checkbox>
                                                <!-- End of Show Parent and Use OrderKeyDate manually -->
                                            </div>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-panel-description>
                </mat-expansion-panel>
            </mat-accordion>
        </div>}
        <div class="col-md-12 nopadding">
            <p-treeTable #tt 
                id="parent-child-event-tree-table"
                [value]="eventTreeData" 
                [columns]="cols" 
                selectionMode="single" 
                [paginator]="true"
                [rows]="rows"
                alwaysShowPaginator="true"
                paginatorPosition="top" 
                [rowsPerPageOptions]=constantService.DEFAULT_ROWSPERPAGEOPTION
                [pageLinks]=constantService.DEFAULT_PAGELINKS
                [(selection)]=selectedNode
                (onNodeCollapse)="nodeUnselect($event)" 
                (onNodeExpand)="nodeSelect($event)" 
                [lazy]="false"
                [totalRecords]="totalRecords"
                showGridlines
                styleClass="treeTable">               
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns.length">
                            {{isDataLoading?constantService.LOADIND_DATA_MSG:constantService.NO_RECORDFOUND_MSG}}
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        @for (col of cols; track col.label; let i = $index){
                        <th [id]="col.header">
                            <span> {{col.header}}</span>
                        </th>}
                    </tr>
                    <tr>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
                    <tr [ttRow]="rowNode" [ngClass]="rowData['firmROEID']==firmROEID?'main-parent-row':(rowData['rsmsStatus'] | lowercase)== 'e' ? 'ui-widget-error-row':'parent-row'">
                        @for (col of columns; track col.label; let i = $index){
                        <td 
                        [ngClass]="rowData['firmROEID']==firmROEID?'main-parent-row':(rowData['rsmsStatus'] | lowercase)== 'e' ? 'ui-widget-error-row':'parent-row'">
                        @if(i == 0){   
                        <p-treeTableToggler [rowNode]="rowNode" class="ui-treetable-toggler">
                            </p-treeTableToggler>}
                            <!-- set Date -->
                             @if((col.datatype | lowercase) =='date'){
                            <span>
                                @if(rowData[col.field] && rowData[col.field]!='null'){
                                <span>{{rowData[col.field] | date: 'yyyy-MM-dd'
                                    }}</span>}
                            </span>}

                            <!-- set String -->
                             @if((col.datatype | lowercase) =='string'){
                            <span>
                                @if(rowData[col.field]!='null' && rowData[col.field]!=''){
                                <span>{{rowData[col.field] }}</span>}
                            </span>}
                            @if((col.datatype | lowercase) =='boolean'){
                            <span>
                                <span>{{rowData[col.field] }}</span>
                            </span>}
                            <!-- set int  -->
                             @if((col.datatype | lowercase) =='int' || (col.datatype | lowercase) =='float'){
                            <span style="float:right;">
                                @if(rowData[col.field] && rowData[col.field]!='null'){
                                <span>{{rowData[col.field] * 1 }}</span>}
                            </span>}
                        </td>}
                    </tr>
                </ng-template>
                <ng-template pTemplate="paginatorright">
                    <p-button type="button" id="tree-expand-collapse" label="Expand/Collapse"
                        (onClick)="exapandORcollapse(eventTreeData)">
                    </p-button>
                
                    <button type="button" [matTooltip]="this.userService.enableFileExport()?'Export':'Export service is disabled' "
                     [matTooltipShowDelay]="1000" id="export-tree" label="export-tree" class="exportBtn"
                        (click)="exportToCSV()"> Export <i class="fa fa-download" aria-hidden="true"></i>
                    </button>
                    <button type="button" [matTooltip]="this.userService.enableFileExport()?'Export':'Export service is disabled' "
                     [matTooltipShowDelay]="1000" id="export-tree" label="export-tree" class="exportBtn"
                        (click)="exportToCSV('ExportAll')"> Export All CAT Fields <i class="fa fa-download" aria-hidden="true"></i>
                    </button>
                
                </ng-template>
                <ng-template pTemplate="paginatorleft" let-state>
                                       Total Records: {{totalRecords}}
                  </ng-template>
                <ng-template let-item pTemplate="paginatordropdownitem">
                    {{item.value}}
                </ng-template>
            </p-treeTable>
        </div>


